import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInProgressIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			transform: "translate(0 0.00195312)",
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8.00195,
			r: 7.5,
			fill: "#F8C782"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3033 13.3053C12.4312 14.1774 11.3574 14.821 10.1771 15.179C8.99686 15.537 7.74651 15.5985 6.53682 15.3578C5.32714 15.1172 4.19547 14.582 3.24205 13.7995C2.28863 13.0171 1.5429 12.0116 1.0709 10.8721C0.598909 9.73258 0.415222 8.49427 0.536114 7.26683C0.657007 6.03938 1.07875 4.8607 1.76398 3.83518C2.44921 2.80966 3.37678 1.96896 4.46452 1.38755C5.55227 0.806132 6.76661 0.501954 8 0.501953L8 8.00195L13.3033 13.3053Z",
			fill: "#D97F00"
		})
	]
});
const ForwardRef = forwardRef(SvgInProgressIcon);
export default ForwardRef;
